import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Link } from 'ui-components/common/Link';

interface KeywordProps {
  className?: string;
  keyword: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

const KEYWORD_STYLES = {
  base: 'cursor-pointer justify-center px-[4px] py-[1px]',
  content: {
    container: 'inline-block rounded bg-gray-200',
    text: 'text-xxxs leading-[18px] font-medium !text-gray-600',
  },
} as const;

export const PromotionReplyKeyword = ({ className, keyword, onClick }: KeywordProps) => {
  const href = `/search?q=${encodeURIComponent(`${keyword}`)}`;

  return (
    <Link
      href={href}
      className={twMerge(className, KEYWORD_STYLES.base, KEYWORD_STYLES.content.container, KEYWORD_STYLES.content.text)}
      onClick={onClick}>
      {keyword}
    </Link>
  );
};
